import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/coolblue.webp';
import screenshot_target from '../../../images/letterfunnel/pieterzwart.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="full_asdfoijaspdoifj"
      firstname="first_asdfasdf"
      companyname="COMPANPOASDFOIJE"
      competition="AmazonenBol"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/_example.js